export default "__VITE_ASSET__DYswsjxI__"